import { ReadOnlyOwaUserConfiguration } from 'owa-service/lib/ReadOnlyTypes';

export default function getConditionalAccessString(
    owaUserConfiguration: ReadOnlyOwaUserConfiguration
): string {
    const attachmentPolicy = owaUserConfiguration.AttachmentPolicy || {};

    if (
        attachmentPolicy.ConditionalAccessDirectFileAccessOnPrivateComputersBlocked ||
        attachmentPolicy.ConditionalAccessDirectFileAccessOnPublicComputersBlocked
    ) {
        if (
            attachmentPolicy.ConditionalAccessWacViewingOnPrivateComputersBlocked ||
            attachmentPolicy.ConditionalAccessWacViewingOnPublicComputersBlocked
        ) {
            return 'ReadOnlyPlusAttachmentsBlocked';
        } else {
            return 'ReadOnly';
        }
    }
    return 'None';
}
